<template>
    <sidebar-tab :card_on_mobile="true" on_tab="main">
        <form-row>
            <form-field>
                <div class="tw-flex tw-items-center">
                    <i class="far fa-users tw-pr-2 tw-pt-px"></i>
                    <p>
                        <b>{{ tEvent.members_count - 1 }}</b>
                        <template v-if="tEvent.members_count - 1 === 1">
                            {{ $t('events.singular_going')}}
                        </template>
                        <template v-else>
                            {{ $t('events.going')}}
                        </template>
                    </p>
                </div>
                <div v-if="filteredMembers.length > 0" class="tw-grid tw-grid-cols-5 tw-gap-y-3 tw-mt-5">
                    <a :href="'/profile/' + member.user.username" v-for="member in filteredMembers" :key="member.id">
                        <img :src="member.user.avatar" class="event-member-avatar tw-rounded-full tw-border tw-border-white">
                    </a>
                </div>
                <p v-else class="tw-mb-2 tw-mt-2 tw-text-gray-500 tw-text-sm">{{ $t('events.no_one_yet') }}.</p>

                <router-link :to="{name: 'events.show', params: { event_slug: tEvent.slug, tab: 'members' }}" class="tw-mt-2 tw-block secondary-c tw-text-sm hover:tw-opacity-75" v-if="totalMemberPages > 1">{{ $t('events.members_show_more') }}</router-link>
            </form-field>
        </form-row>
    </sidebar-tab>
</template>

<script>
    import Global from '../../../mixins/Global';

    export default {
        name: 'GroupsSidebarModerators',

        mixins: [Global],

        props: {
            tEvent: {
                required: true,
            },
            members: {
                required: true,
            },
            totalMemberPages: {
                required: true,
            },
        },

        computed: {
            filteredMembers() {
                return this.members.filter(member => (member.user !== null && member.status !== 'invited' && member.status !== 'pending'));
            },
        },
    };
</script>

<style lang="scss" scoped>
    .event-member-avatar {
        height: 42px;
        width: 42px;
    }
</style>
